module.exports = __webpack_public_path__ + "static/downtime-hero-5c9f3847a56bdd03ec541eb192107b2e.svg";